import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import question01 from './assets/question01.png';
import question02 from './assets/question02.png';
import transcript01 from './assets/transcript01.PNG';
import transcript02_01 from './assets/transcript02_01.PNG';
import transcript02_02 from './assets/transcript02_02.PNG';

function SpeakingInstruction() {
    const location = useLocation();
    const navigate = useNavigate();
    const { target } = location.state || {};

    const videoUrl01 = "https://cdnapisec.kaltura.com/p/5394802/embedPlaykitJs/uiconf_id/53315462?iframeembed=true&entry_id=1_xxuozjso&config%5Bprovider%5D=%7B%22widgetId%22%3A%221_q2qn0yqh%22%7D&config%5Bplayback%5D=%7B%22startTime%22%3A0%7D";
    const videoUrl02 = "https://cdnapisec.kaltura.com/p/5394802/embedPlaykitJs/uiconf_id/53315462?iframeembed=true&entry_id=1_eco5deq2&config%5Bprovider%5D=%7B%22widgetId%22%3A%221_2afh6wan%22%7D&config%5Bplayback%5D=%7B%22startTime%22%3A0%7D";

    const renderContent = () => {
        switch (target) {
            case 'class-lecture':
                return (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-[#001670]">Class Lecture: HEXA'S IELTS Preparation Coursebook (Speaking)</h2>
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <p className="text-lg leading-relaxed">
                                This section contains the class lecture materials from HEXA'S IELTS Preparation Coursebook for Speaking Part 02.
                                Please refer to your coursebook for the complete lecture content.
                            </p>
                        </div>
                    </div>
                );
            case 'guided-practice-01':
                return (
                    <div className="space-y-8">
                        <h2 className="text-2xl font-bold text-[#001670]">Guided Practice 01</h2>
                        
                        {/* Question Section */}
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-[#001670] mb-4">Question</h3>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <img 
                                    src={question01} 
                                    alt="Speaking Question 01" 
                                    className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                />
                            </div>
                        </div>

                        {/* Recording Section */}
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-[#001670] mb-4">Recording</h3>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                {/* Video Player */}
                                <div className="mb-4">
                                    <iframe
                                        src={videoUrl01}
                                        className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                        style={{ height: '300px' }}
                                        frameBorder="0"
                                        allowFullScreen
                                        title="Speaking Practice Video 01"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Transcript Section */}
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-[#001670] mb-4">Transcript</h3>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <img 
                                    src={transcript01} 
                                    alt="Speaking Transcript 01" 
                                    className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                />
                            </div>
                        </div>
                    </div>
                );
            case 'guided-practice-02':
                return (
                    <div className="space-y-8">
                        <h2 className="text-2xl font-bold text-[#001670]">Guided Practice 02</h2>
                        
                        {/* Question Section */}
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-[#001670] mb-4">Question</h3>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <img 
                                    src={question02} 
                                    alt="Speaking Question 02" 
                                    className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                />
                            </div>
                        </div>

                        {/* Recording Section */}
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-[#001670] mb-4">Recording</h3>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                {/* Video Player */}
                                <div className="mb-4">
                                    <iframe
                                        src={videoUrl02}
                                        className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                        style={{ height: '300px' }}
                                        frameBorder="0"
                                        allowFullScreen
                                        title="Speaking Practice Video 02"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Transcript Section */}
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-[#001670] mb-4">Transcript</h3>
                            <div className="bg-gray-50 p-4 rounded-lg space-y-4">
                                <img 
                                    src={transcript02_01} 
                                    alt="Speaking Transcript 02 Part 1" 
                                    className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                />
                                <img 
                                    src={transcript02_02} 
                                    alt="Speaking Transcript 02 Part 2" 
                                    className="w-full max-w-2xl mx-auto rounded-lg shadow-sm"
                                />
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-[#001670]">Class 02: Speaking Part 02</h2>
                        <div className="bg-white p-6 rounded-lg shadow-md">
                            <p className="text-lg leading-relaxed">
                                Welcome to Class 02 of the Speaking Module. Please select a topic from the navigation.
                            </p>
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#f5f7fa] to-[#e4e8f0] p-8">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="flex items-center justify-between mb-8">
                    <button
                        onClick={() => navigate('/')}
                        className="bg-[#001670] text-white px-4 py-2 rounded-lg hover:bg-[#001670]/90 transition"
                    >
                        ← Back to Home
                    </button>
                    <h1 className="text-3xl font-bold text-[#001670]">Speaking Module</h1>
                </div>

                {/* Content */}
                {renderContent()}
            </div>
        </div>
    );
}

export default SpeakingInstruction; 